import { Button, CardMedia, Grid, TextField, Typography } from "@mui/material";
import { Box, bgcolor } from "@mui/system";
import * as React from "react";
import "./style/GeneralDetailUpdate.css";
import UploadComp from "../../common/components/CustomisedUpload";
import { callApi } from "../../common/api";
import CustomizedSnackbars from "../alert/alert";
import KycComp from "../../common/components/CustomisedKyc";

export default function KycDetails() {
  const [inputData, setInputData] = React.useState({
    passportNumber: "",
    isPassportValid: true
  });
  const [fileData, setFileData] = React.useState({
    passFront: "",
    passBack: "",
  });
  const [snackBarMsg, setSnackBarMsg] = React.useState({
    message: "",
    severity: "success",
    open: false,
  });
  const [selected, setselected] = React.useState(1);

  const KycStatus = {
    0: "Pending",
    1: "Send To Verify",
    2: "Rejected",
    3: "Un-Identified",
    4: "Verified"
  }

  const [status, setStatus] = React.useState("")
  const [bgColor, setbgColor] = React.useState("")



  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const passportNumberPattern = /^[A-Z0-9]{8,15}$/;
    const isPassportValid = passportNumberPattern.test(value);
    setInputData({
      ...inputData,
      [name]: value.toUpperCase(),
      isPassportValid,
    });
  };

  async function handleFileData(e) {
    const name = e.target.name;
    const file = e.target.files[0];
    const allowedTypes = ["application/pdf", "image/jpeg", "image/png", "image/gif"];
  
    if (file && !allowedTypes.includes(file.type)) {
      setSnackBarMsg({
        message: "Only PDF and image files are allowed.",
        severity: "error",
        open: true,
      });
      return;
    }
  
    setFileData((prevState) => ({
      ...prevState,
      [name]: file,
    }));
  }
  

  async function handleUpdate(e) {
    e.preventDefault();
    const isAnyFieldEmpty = Object.values(fileData).some(value => value === "");

    if (isAnyFieldEmpty) {
      setSnackBarMsg({
        message: "Please fill all the fields.",
        severity: "error",
        open: true,
      });
      return;
    } else if (!inputData?.isPassportValid) {
      setSnackBarMsg({
        message: "Please enter valid passport number.",
        severity: "error",
        open: true,
      });
      return
    }

    let formData = new FormData();
    formData.append("passportNumber", inputData.passportNumber);
    formData.append("passPortBack", fileData.passBack);
    formData.append("passPortFront", fileData.passFront);

    try {
      const response = await callApi(
        "post",
        "investor/kyc",
        formData,
        { "content-type": "application/x-www-form-urlencoded" },
        true,
        true
      );
      if (response.data.response.status) {
        setSnackBarMsg({
          message: "Details Edit Successfully",
          severity: "success",
          open: true,
        });
        setselected(1);
        handleGet();
      } else {
        setSnackBarMsg({
          message: "Some error occur",
          severity: "error",
          open: true,
        });
      }
    } catch {
      setSnackBarMsg({
        message: "Some error occur",
        severity: "error",
        open: true,
      });
    }
  }
  async function HandleEdit() {
    setselected(0);
  }
  async function handleGet() {
    try {
      const response = await callApi("get", "investor/kycDetails");
      setStatus(response?.data?.response?.data?.kycStatus)

      const statuses = response?.data?.response?.data?.kycStatus

      if (statuses === 0) {
        setbgColor("#A38921")
      }
      if (statuses === 1) {
        setbgColor("orange")
      }
      if (statuses === 2) {
        setbgColor("red")
      }
      if (statuses === 3) {
        setbgColor("#FFBBBA")
      }
      if (statuses === 4) {
        setbgColor("green")
      }

      if (response.data.response.data) {
        setInputData((prevData) => ({
          ...prevData,
          passportNumber: response.data.response.data.passportNumber,
          // isPassportValid
        }))
        const data = response.data.response.data.userDocuments || [];

        data.forEach((element) => {
          if (element.documentName === 7) {
            setFileData((prevData) => ({
              ...prevData,
              passFront: element,
            }));
          } else if (element.documentName === 8) {
            setFileData((prevData) => ({
              ...prevData,
              passBack: element,
            }));
          }
        });
        if (data.length > 0) {
          // setSnackBarMsg({
          //   message: "Data Get Successfully",
          //   severity: "success",
          //   open: true,
          // });
        }
      }
      // else {
      //   setSnackBarMsg({
      //     message: "Please apply for KYC ",
      //     severity: "warning",
      //     open: true,
      //   });
      // }
    } catch {
      // not to do anything when data is empty
    }
  }
  React.useEffect(() => {
    handleGet();
  }, []);

  const handleDelete = (name, fileInputRef) => {
    setFileData((prevState) => (
      {
        ...prevState,
        [name]: null
      }))
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  }
  
  return (
    <>
      <div className="col-lg-12 col-md-12 col-sm-12 col-12 marginTop">

        <div style={{ display: "flex", borderBottom: '1px solid white', marginBottom: "30px" }}>
          <h2 style={{ width: "90%", borderBottom: "none", marginBottom: "5px" }}>KYC</h2>
          <div style={{
            height: "40px",
            padding: "1px",
            width: "120px",
            display: "flex",
            color: "white",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: bgColor,
            borderRadius: "5px",
            whiteSpace: "nowrap"
          }}>{KycStatus[status]}
          </div>
        </div>
        {selected === 1 ? (
          <div className="general-detail-box investorformpage">
            <div className="row">
              <div className="col-3">
                <div className="ltdetail">
                  <p>Passport Number</p>
                </div>
              </div>
              <div className="col-9">
                <div className="rtdetail">
                  <p>{inputData.passportNumber ? inputData.passportNumber : <span style={{ color: "grey" }}>--</span>}</p>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-6 col-md-6 col-sm-12 col-12" style={{ gap: "16px" }}>
                <div className="col-8">
                  <div className="ltdetail">
                    <p>Passport Front Image</p>
                  </div>
                </div>
                {fileData && fileData.passFront ?
                  <CardMedia
                    component="img"
                    alt="Example Image"
                    height="150"
                    image={fileData.passFront.link}
                  /> :
                  "--"
                }
              </div>
              <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                <div className="col-8">
                  <div className="ltdetail">
                    <p>Passport Back Image</p>
                  </div>
                </div>
                {fileData && fileData.passBack ?
                  <CardMedia
                    component="img"
                    alt="Example Image"
                    height="150"
                    image={fileData.passBack.link}
                  /> :
                  "--"
                }
              </div>
            </div>

            <div className="row mt-4">
              <div className="col-12">
                <a style={{ cursor: "pointer", fontWeight: "500" }}
                  className="commanbutton commanbuttonprofile d-block text-center"
                  onClick={HandleEdit}
                >
                  Edit
                </a>
              </div>
            </div>
          </div>
        ) : (
          <div className="general-detail-box ">
            <div class="investorform investorformpage">
              <form>
                <div class="row">
                  <KycComp
                    handleInputChange={handleInputChange}
                    inputData={inputData}
                    handleFileData={handleFileData}
                    fileData={fileData}
                    handleDelete={handleDelete}
                  />
                </div>
                <div class="col-lg-12 col-md-12 col-sm-12 col-12 mt-4">
                  <button
                    type="submit"
                    class="btn d-block w-100 btn-primary"
                    onClick={handleUpdate}
                  >
                    Update
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
      </div>
      <CustomizedSnackbars msgData={snackBarMsg} setMsgData={setSnackBarMsg} />
    </>
  );
}